import { createLazyFileRoute } from "@tanstack/react-router";

import { ITransplantAdminPage } from "@/features/admin/routes/ITransplantAdmin";

export const Route = createLazyFileRoute(
  "/_auth/admin/integrations/itransplant",
)({
  component: ITransplantAdminPage,
});
